import React, {useState, createContext} from 'react'

export const UserContext = createContext()

const movie_api = "https://backendexample.sanbersy.com/api/data-movie"
const game_api = "https://backendexample.sanbersy.com/api/data-game"

export const UserProvider = props => {
  const currentUser = JSON.parse(localStorage.getItem('user'))
  const [user, setUser] = useState(currentUser)
  const [isMovie, setIsMovie] = useState(true)

  return (
    <UserContext.Provider value={{user, setUser, isMovie, setIsMovie, movie_api, game_api}}>
      {props.children}
    </UserContext.Provider>
  )
}